import { getToken } from "@/lib/auth";

const LS_KEY = "macoAnalyst";

export function setActor(name: string): void {
  localStorage.setItem(LS_KEY, name.trim());
}
export function getActorName(): string | null {
  return localStorage.getItem(LS_KEY);
}
export function getActor(): string {
  const n = getActorName();
  return n ? `analyst:${n}` : "anonymous";
}

export class ApiError extends Error {
  constructor(public status: number, public body: any, message: string) {
    super(message);
  }
}

function mergeHeaders(init: HeadersInit | undefined): Record<string, string> {
  const out: Record<string, string> = {};
  if (!init) return out;
  if (init instanceof Headers) {
    init.forEach((v, k) => { out[k] = v; });
  } else if (Array.isArray(init)) {
    for (const [k, v] of init) out[k] = v;
  } else {
    for (const [k, v] of Object.entries(init)) {
      if (v !== undefined) out[k] = String(v);
    }
  }
  return out;
}

export async function apiFetch<T = any>(
  path: string, init: RequestInit = {},
): Promise<T> {
  const headers = mergeHeaders(init.headers);
  headers["X-Actor"] = getActor();
  const token = getToken();
  if (token) headers["Authorization"] = `Bearer ${token}`;
  if (init.body && !("Content-Type" in headers) && !("content-type" in headers)) {
    headers["Content-Type"] = "application/json";
  }
  const res = await fetch(path, { ...init, headers });
  if (!res.ok) {
    let body: any = null;
    try { body = await res.json(); } catch {}
    throw new ApiError(res.status, body, `${res.status} ${path}`);
  }
  const ct = res.headers.get("content-type") ?? "";
  return (ct.includes("application/json") ? res.json() : res.text()) as Promise<T>;
}
